import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { EventDTO } from '../../../app/api/models';
import { ManagementService } from '../../../app/api/services';
import { ChooseEventDialogComponent } from '../../../app/components/dialogs/choose-event-dialog/choose-event-dialog.component';
import { SharedService } from '../../../app/services/shared.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {


  constructor(
    private managementService: ManagementService,
    private sharedService: SharedService,
    private router: Router,
    private dialog: MatDialog,
  ) {
  }

  events: EventDTO[] = [];
  isLoadingPage = true;
  selectedEvent?: EventDTO;


  ngOnInit(): void {

    this.managementService.getEvents(moment(Date()).format('YYYY')).subscribe(res => {
      let event = this.sharedService.event || this.sharedService.getEvent();
      this.events = res.events;
      if (event) {
        this.selectedEvent = this.events.find(e => e.id === event.id);
      }
      this.isLoadingPage = false;
    });

  }

  doneIsPressed() {
    if (this.selectedEvent) {
      this.sharedService.saveEvent(this.selectedEvent);
      this.router.navigateByUrl('/home');
    }
  }

  openDialogChooseEvent() {
    const dialogRef = this.dialog.open(ChooseEventDialogComponent, {
      data: {
        events: this.events,
        selectedEvent: this.selectedEvent,
      },
      panelClass: ['event-container'],
      backdropClass: 'bdrop'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedEvent = result;
      }
    });
  }



}
